import React, { FC, ReactElement } from 'react';
import { CheckCircle, ExclamationCircle } from 'react-bootstrap-icons';

export type UploadStatus = 'idle' | 'uploading' | 'success' | 'error';

export type Upload = {
  progress: number | null;
  status: UploadStatus;
}

type UploadOverlayProps = {
  progress: number | null;
  status: UploadStatus;
};

const UploadOverlay: FC<UploadOverlayProps> = ({ progress, status }: UploadOverlayProps): ReactElement | null => {
  if (status === 'idle') {
    return null;
  }

  const renderCircle = (background: string, content: ReactElement): ReactElement => (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle"
      style={{
        width: '80px',
        height: '80px',
        background,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle bg-white fw-bold"
        style={{
          width: '55px',
          height: '55px',
        }}
      >
        {content}
      </div>
    </div>
  );

  const renderContent = (): ReactElement => {
    if (status === 'uploading' && progress !== null) {
      return renderCircle(`conic-gradient(#007bff ${progress}%, #e9ecef 0%)`, <span>{progress}%</span>);
    }

    if (status === 'success') {
      return renderCircle('conic-gradient(#28a745 100%, #e9ecef 0%)', <span className="fs-2 text-success"><CheckCircle /></span>);
    }

    return renderCircle('conic-gradient(#dc3545 100%, #e9ecef 0%)', <span className="fs-2 text-danger"><ExclamationCircle /></span>);
  };

  return (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-3"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 10,
      }}
    >
      {renderContent()}
    </div>
  );
};

export default UploadOverlay;
